import React from 'react';
import PageHeader, { Highlight } from '../components/ui/PageHeader';
import Button from '../components/ui/Button';
import Chip from '../components/ui/Chip';
import ProgressBar from '../components/ui/ProgressBar';
import BuildConsole from '../components/features/BuildConsole';
import BuildSettingsPanel from '../components/features/BuildSettings';
import DropZone from '../components/features/DropZone';
import { useBuild } from '../hooks/useBuild';

const ConverterPage: React.FC = () => {
  const { buildProgress, buildPhase, buildLogs, startBuild, cancelBuild, isBuilding, isSuccess } = useBuild();

  return (
    <>
      <PageHeader
        title={<>APK <Highlight>Converter</Highlight></>}
        subtitle="Convert React or web apps to Android APK using Capacitor or WebView"
      />

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 20 }}>
        <Chip variant="info">Capacitor 5.x</Chip>
        <Chip variant="info">WebView Mode</Chip>
        <Chip variant="success">✓ Node 20</Chip>
        <Chip variant={isBuilding ? 'warn' : 'muted'}>{isBuilding ? `● ${buildPhase}` : '● Ready'}</Chip>
      </div>

      {/* Method selector */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12, marginBottom: 20 }}>
        {[
          { icon: '◈', name: 'Capacitor', desc: 'Full native bridge, recommended for production apps.' },
          { icon: '⬡', name: 'WebView Wrapper', desc: 'Lightweight wrapper — great for simple web apps.' },
          { icon: '⊞', name: 'React Native Web', desc: 'Convert RNW code to native Android modules.' },
        ].map((m) => (
          <div key={m.name} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', padding: 18, cursor: 'pointer', transition: 'border-color var(--transition-base)' }}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = 'var(--accent)')}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = 'var(--border)')}
          >
            <div style={{ fontSize: 22, marginBottom: 8 }}>{m.icon}</div>
            <div style={{ fontWeight: 700, fontSize: '0.9rem', marginBottom: 4 }}>{m.name}</div>
            <div style={{ fontSize: '0.78rem', color: 'var(--text-muted)', lineHeight: 1.5 }}>{m.desc}</div>
          </div>
        ))}
      </div>

      <DropZone accept={['.html', '.js', '.zip', '.tar.gz']} hint="Drop your React / web project folder as a .zip archive" />
      <BuildSettingsPanel />

      {buildProgress > 0 && <ProgressBar value={buildProgress} label={buildPhase || 'Converting...'} />}

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 20 }}>
        <Button variant="purple"    icon="◈"  onClick={startBuild} disabled={isBuilding} loading={isBuilding}>
          {isBuilding ? 'Converting...' : 'Convert to APK'}
        </Button>
        <Button variant="secondary" icon="⊞" disabled={isBuilding}>Preview WebView</Button>
        <Button variant="danger"    icon="✕" disabled={!isBuilding} onClick={cancelBuild}>Cancel</Button>
      </div>

      <BuildConsole logs={buildLogs} isBuilding={isBuilding} />

      {isSuccess && (
        <div style={{ display: 'flex', gap: 10 }}>
          <Button variant="primary" icon="⬇">Download APK</Button>
          <Button variant="secondary" icon="⧉">Share</Button>
        </div>
      )}
    </>
  );
};

export default ConverterPage;
